export default __webpack_public_path__ + "static/media/connected.12b9655c.jpg";